import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

/**
 * Renders a small 4x4 dot which indicates that a value is aliased or renamed
 */

interface IProps {
  className?: string;
  isDisabled?: boolean;
}

const Container = styled.span<{ $isDisabled?: boolean }>`
  flex: 0 0 auto;
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: ${({ $isDisabled }) =>
    $isDisabled ? theme.colors.secondary400 : theme.colors.secondary600};
  vertical-align: middle;
  user-select: none;
`;

export default ({ className, isDisabled }: IProps) => (
  <Container className={className} $isDisabled={isDisabled} />
);
